import style from './style.css';
import UserEligibilityContainer from './userEligibiltycontainer';
import VerifyEligibilityButton from './verifyEligibilityButton';
import { Fragment } from 'preact';
import withBaseComponent from '../../../HOC/withBaseComponent';
import { useState, useEffect } from 'preact/hooks';
import OverlayScreen from '../overlayScreen';
import OverlayEligibiltyCheck from '../overlayEligibiltyCheck';
import ntbAction from '../../../actions/ntbAction';
import { useDispatch } from 'react-redux';
import actionType from '../../../actions/ntbAction/actionType';
import { PageLoadType, tracker } from '../../../tracking';

const CheckEligibility = ({}) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    const dispatch = useDispatch();
    dispatch(ntbAction(actionType.closeOtpOverLayScreen));
  };

  const pageKey = 'pv_bic_context_card';
  const overlaySizeClassName = 'overlay-wd-medium';

  useEffect(() => {
    if (showOverlay) {
      return (document.body.style.overflowY = 'hidden');
    }
    document.body.style.overflowY = 'auto';
  }, [showOverlay]);

  useEffect(() => {
    return tracker.trackPageView(PageLoadType.DYNAMIC, pageKey, {
      status: 'guest',
    });
  }, []);

  return (
    <Fragment>
      <div className={style.checkEligibilityContainer}>
        <div className={style.cardContainer}>
          <div className={style.cardWrapper}>
            <UserEligibilityContainer />
            <div className={style.submitContainer}>
              <VerifyEligibilityButton
                buttonId='eligibility-button'
                pageKey={pageKey}
                buttonWrapperClass={style.submitButton}
                elementName='bic_check_eligibility_cta'
                buttonText={<Fragment>Check Eligibility</Fragment>}
                buttonOnClick={() => {
                  setShowOverlay(true);
                }}
              />
            </div>
            <div className={style.startShoppingContainer}>
              <div className={style.startShoppingText}>
                Start shopping with Cardless EMI from your bank
              </div>
              <div className={style.lenderLogo}>
                <div className={style.logoContainer}>
                  <img
                    src='https://iccdn.in/img/hdfc-logo-icon-v2.png'
                    className={style.lenderIcon}
                    alt='lender-logo'
                  />
                </div>
                <div className={style.logoContainer1}>
                  <img
                    src='https://iccdn.in/img/kotak-icon-v1.png'
                    className={style.lenderIcon}
                    alt='lender-logo'
                  />
                </div>
                <div className={style.subText}>+5</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showOverlay && (
        <OverlayScreen
          handleCloseOverlay={handleCloseOverlay}
          showOverlay={showOverlay}
          overlaySizeClassName={overlaySizeClassName}>
          <OverlayEligibiltyCheck
            handleCloseOverlay={handleCloseOverlay}
            ntbAction={ntbAction}
          />
        </OverlayScreen>
      )}
    </Fragment>
  );
};

export default withBaseComponent(CheckEligibility);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/checkEligibilty/index.js